import React, { memo } from 'react';
import classNames from 'classnames';
import { Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { AlyceTheme } from '@alycecom/ui';

import useResponsive from '../../../../hooks/useResponsive';

const useStyles = makeStyles<AlyceTheme, { flipStyles: boolean }>(({ palette, spacing }) => ({
  title: ({ flipStyles }) => ({
    textAlign: 'center',
    marginBottom: spacing(flipStyles ? 1 : 0),
    color: palette.text.primary,
    wordBreak: 'break-word',
    wordWrap: 'break-word',
  }),
  subTitle: ({ flipStyles }) => ({
    marginBottom: spacing(!flipStyles ? 1 : 0),
    color: palette.text.primary,
    wordBreak: 'break-word',
    wordWrap: 'break-word',
  }),
  mobileSubTitle: {
    fontSize: '14px !important',
  },
}));

export interface IPageTitleProps {
  title: React.ReactNode;
  subTitle?: React.ReactNode;
  flipStyles?: boolean;
  children?: React.ReactNode;
}

const PageTitle = ({ title, subTitle, flipStyles = false, children }: IPageTitleProps) => {
  const { isMobile } = useResponsive();
  const classes = useStyles({ flipStyles });
  const titleClass = isMobile ? 'H4-Dark-Bold' : 'H2-Dark';

  const titleClasses = classNames(titleClass, classes.title);
  const subTitleClasses = classNames('Body-Regular-Center-Static', classes.subTitle, {
    [classes.mobileSubTitle]: isMobile,
  });

  return (
    <>
      {subTitle && (
        <Typography className={flipStyles ? titleClasses : subTitleClasses} data-testid="acceptPageTitle">
          {subTitle}
        </Typography>
      )}
      <Typography className={flipStyles ? subTitleClasses : titleClasses} data-testid="acceptPageTitleBody">
        {title}
      </Typography>
      {children}
    </>
  );
};

export default memo(PageTitle);
